module.exports = __webpack_public_path__ + "static/staple-icon-42b80960acb8ead82862b858d82d42c2.png";